<template>
  <div class="mobile-footer-menu text-center">
    <router-link
      tag="button"
      circle
      class="ad1-button el-icon-plus"
      :to="{ name: isUser ? 'CreateAd' : 'Welcome' }"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    computed: {
      ...mapState({
        isUser: state => !!state.auth.user,
      }),
    },
  }
  ;
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/FooterMenu.vue